import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Loader2, Plus } from "lucide-react";

const FIELDS = [
  { key: "name", label: "Company Name", required: true, placeholder: "e.g., Storm Shield Construction" },
  { key: "address", label: "Address", placeholder: "Street, city, state" },
  { key: "phone", label: "Phone", placeholder: "+14075550000" },
  { key: "website", label: "Website", placeholder: "https://example.com" },
  { key: "email", label: "Email", placeholder: "contact@example.com" },
  { key: "sector", label: "Sector", placeholder: "Waterproofing / Roofing / Plumbing" },
];

export default function ManualAddModal({ open, onOpenChange, onSubmit, submitting }) {
  const [form, setForm] = useState({ name: "", address: "", phone: "", website: "", email: "", sector: "", notes: "" });

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    await onSubmit(form);
    setForm({ name: "", address: "", phone: "", website: "", email: "", sector: "", notes: "" });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="manual-add-modal"
        className="max-w-xl bg-white p-0 overflow-hidden rounded-xl border-[#E5E7EB]"
      >
        <DialogHeader className="px-6 pt-5 pb-4 border-b border-[#E5E7EB]">
          <DialogTitle className="text-[18px] font-bold text-[#111827]">
            Add Virtual Business Manually
          </DialogTitle>
          <p className="text-[12px] text-[#6B7280] mt-1">
            Saved directly to your CRM and Google Sheets.
          </p>
        </DialogHeader>

        <form onSubmit={submit} className="px-6 py-5 space-y-3 max-h-[70vh] overflow-y-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {FIELDS.map((f) => (
              <div key={f.key} className={f.key === "name" ? "sm:col-span-2" : ""}>
                <label className="block text-[12px] font-semibold text-[#6B7280] mb-1.5">
                  {f.label} {f.required && <span className="text-[#EF4444]">*</span>}
                </label>
                <input
                  data-testid={`manual-${f.key}-input`}
                  required={f.required}
                  value={form[f.key]}
                  onChange={(e) => update(f.key, e.target.value)}
                  placeholder={f.placeholder}
                  className="w-full h-10 px-3.5 rounded-lg border border-[#E5E7EB] focus:outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-[#3B82F6]/15 text-[14px]"
                />
              </div>
            ))}
          </div>
          <div>
            <label className="block text-[12px] font-semibold text-[#6B7280] mb-1.5">Notes</label>
            <textarea
              data-testid="manual-notes-textarea"
              value={form.notes}
              onChange={(e) => update("notes", e.target.value)}
              rows={3}
              placeholder="Internal notes about this prospect"
              className="w-full p-3 rounded-lg border border-[#E5E7EB] focus:outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-[#3B82F6]/15 text-[14px] resize-y"
            />
          </div>
          <div className="flex justify-end pt-2">
            <button
              data-testid="manual-save-btn"
              disabled={submitting}
              className="al-btn-primary flex items-center gap-1.5 px-5 h-10 rounded-lg text-[13px] font-medium disabled:opacity-60"
            >
              {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}
              Save Business
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
